// extracted by mini-css-extract-plugin
export default {"maxHeightDropdown":"tPWGaEA6hkDguh_zBhzi"};